var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpaceComet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 203.95 82.92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: #fccc4f;\n        mix-blend-mode: screen;\n        opacity: .6;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4, .cls-5 {\n        mix-blend-mode: multiply;\n        opacity: .4;\n      }\n\n      .cls-6 {\n        isolation: isolate;\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -35.68,
    y1: 77.66,
    x2: 248.33,
    y2: -38.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6000a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#8b25f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe00f4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 15.04,
    y1: 46.58,
    x2: 278.99,
    y2: -8.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 540.73,
    y1: 56.55,
    x2: 572.13,
    y2: 126.51,
    gradientTransform: "translate(-535.98 56.71) rotate(-11.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fb45a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#f6e013"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#f6d51d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#f7b83b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#f9896a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#fb48ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#fe00f4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 555.47,
    y1: 89.37,
    x2: 574.61,
    y2: 132.03,
    xlinkHref: "#linear-gradient-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M28.2,14.8l33.86,59.91C100.78,35.09,203.95,8,203.95,8,78.69-13.36,28.2,14.8,28.2,14.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.41,30.85l11.94,20.85S116.07,21.11,203.48,7.96c-7.32-.65-93.72-3.84-159.07,22.89Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M67.96,31.41c-.41-.71-1.17-1.14-1.99-1.11l-21.38.76-13.56-16.54c-1.04-1.27-3.37-.79-3.82.79l-5.88,20.56L1.4,43.66c-.76.3-1.3.99-1.39,1.81-.09.81.28,1.61.96,2.07l17.74,11.95,1.25,21.36c.05.81.55,1.54,1.29,1.88.75.33,1.62.23,2.26-.28l16.85-13.17,20.69,5.41c.34.09.68.09,1,.03.45-.09.86-.33,1.19-.67.55-.6.72-1.47.44-2.24l-7.33-20.1,11.54-18.01c.44-.69.47-1.57.06-2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M23.78,81.18l-1.33-22.37-15.49-10.44c-.68-.46-1.05-1.26-.96-2.07.09-.82.63-1.51,1.39-1.81l18.27-6.88,5.37-21.97c.07-.26.21-.48.37-.67l-.37-.45c-1.04-1.27-3.37-.79-3.82.79l-5.88,20.56L1.4,43.66c-.76.3-1.3.99-1.39,1.81-.09.81.28,1.61.96,2.07l17.74,11.95,1.25,21.36c.05.81.55,1.54,1.29,1.88.75.33,1.62.23,2.26-.28l.52-.4c-.14-.27-.24-.55-.25-.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M67.96,31.41c-.41-.71-1.17-1.14-1.99-1.11l-14.86.53c-2.93,16.49-15.1,30.41-32.02,35l.88,15.01c.05.81.55,1.54,1.29,1.88.75.33,1.62.23,2.26-.28l16.85-13.17,20.69,5.41c.34.09.68.09,1,.03.45-.09.86-.33,1.19-.67.55-.6.72-1.47.44-2.24l-7.33-20.1,11.54-18.01c.44-.69.47-1.57.06-2.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M44.41,30.85l-13.39-16.33c-1.04-1.27-3.37-.79-3.82.79l-5.88,20.56-18.19,7.11c6.12,2.18,12.88,2.81,19.71,1.4,8.94-1.85,16.42-6.83,21.57-13.54Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceComet);
export default __webpack_public_path__ + "static/media/SPACE_COMET.63192e2243b53a59e3b82513ee0be52c.svg";
export { ForwardRef as ReactComponent };